<template>
<div class="chapter">
<div class="inner_page">
<div id="tp">
<p class="tit"><big>How to Sew:<br/>Appliqué</big></p>
<p class="stit">
<br/>
<br/>
<br/><br/><br/><br/><br/><br/><br/>
</p>
<p class="center">
<img alt="logo" src="images/logo.jpg" style="max-width: 100%;"/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9780715338773_epub_tp.vue?0979fe88